import { Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomAttachFilesComponent } from 'src/app/components/custom-attach-files/custom-attach-files.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { ConstructionSiteStateEnums } from 'src/app/enum/construction-site-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { QuotationStateEnums, QuotationTypesEnums } from 'src/app/enum/quotation-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { QuotationVersionModel } from 'src/app/models/preliminaries/quotation-version.model';
import { QuotationModel } from 'src/app/models/preliminaries/quotation.model';
import { QuotationPrintModel } from 'src/app/models/print/preliminaries/quotation-print.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { GeneralParameterService } from 'src/app/services/management/general-parameter.service';
import { OrderService } from 'src/app/services/preliminaries/order.service';
import { QuotationVersionService } from 'src/app/services/preliminaries/quotation-version.service';
import { QuotationService } from 'src/app/services/preliminaries/quotation.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { PrintVersionComponent } from '../../quotation-version/print-version/print-version.component';
import { RegisterQuotationVersionComponent } from '../../quotation-version/register-quotation-version/register-quotation-version.component';
import { RejectQuotationComponent } from '../reject-quotation/reject-quotation.component';
import { OrderTypeEnums } from 'src/app/enum/order-enums';
import { RegisterQuotationModalComponent } from '../register-quotation-modal/register-quotation-modal.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-register-quotation',
  templateUrl: './register-quotation.component.html',
  styleUrls: ['./register-quotation.component.scss'],
  standalone: false
})
export class RegisterQuotationComponent implements OnInit {
  @ViewChild('versionModal') versionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('registerModal') registerModalComponent?: CustomModalComponent | null = null;
  @ViewChild('rejectQuotation') rejectQuotationComponent?: CustomModalComponent | null = null;
  @ViewChild('printQuotation') printQuotationComponent?: CustomModalComponent | null = null;
  @ViewChild('attachFile') attachFileComponent?: CustomModalComponent | null = null;

  branchId: number = 0;
  branchContract: BranchModel = new BranchModel();
  breakpointsForPrint: { [key: string]: string } = {
    '1024px': '50vw',
    '768px': '60vw',
    '560px': '90vw'
  };
  companyId: number = 0;
  clientId: number = 0;
  clientStateId: number = ClientStateEnums.activo;
  costCenterDetailsCount: number = 0;
  componenteQuotationVersion = RegisterQuotationVersionComponent;
  componentRejectQuotation = RejectQuotationComponent;
  componentPrintQuotation = PrintVersionComponent;
  componentAttachFiles = CustomAttachFilesComponent;
  componentRegisterModal = RegisterQuotationModalComponent;
  disabledActions: boolean = true;
  disabledBtnVersion: boolean = false;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  expandedForm: boolean = true;
  finishLoadingPrint: boolean = false;
  filteredConstructionSites: any[] = [];
  formQuotation: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  inputsForVersionModals$ = new BehaviorSubject<any>({
    quotationModel: new QuotationModel(),
    permissionUpdatable: false
  });
  inputsForRegisterModal$ = new BehaviorSubject<any>({
    quotationModel: new QuotationModel(),
    permissionUpdatable: false,
    listTypesBussinesses1: [],
    listTypesBussinesses2: [],
    listTypesEquipment: []
  });
  inputsForRejectQuotation$ = new BehaviorSubject<any>({
    quotationModel: new QuotationModel()
  });
  inputsForPrintQuotation$ = new BehaviorSubject<any>({
    selectedVersionContract: new QuotationVersionModel(),
    listVersions: []
  });
  inputsForAttachFiles$ = new BehaviorSubject<any>({
    listFiles: [],
    labelConsecutive: 0,
    disabled: false
  });
  mainBranchByUser: BranchModel = new BranchModel();
  severityState: string = "danger";
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listConstructionSites: any[] = [];
  listClients: any[] = [];
  listFiles: any[] = [];
  listPricesList: any[] = [];
  listSellers: any[] = [];
  listTypesBussinesses1: any[] = [];
  listTypesBussinesses2: any[] = [];
  listTypesEquipment: any[] = [];
  listTypesQuotations: any[] = [];
  listVersions: any[] = [];
  listObservers: Array<Subscription> = new Array<Subscription>();
  nameWindow: string = 'Captura Cotizaciones';
  orderConsecutive: string = '';
  orderId: number = 0;
  titleState: string = "";
  outputForVersionModals$ = new Subject<any>();
  outputForRejectQuotation$ = new Subject<any>();
  outputForPrintQuotation$ = new Subject<any>();
  outputForAttachFiles$ = new Subject<any>();
  permissionUpdatable: boolean = false;
  permissionPrint: boolean = false;
  permissionsUser: OptionWindowModel[] = [];
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  quantityVersions: number = 0;
  quotationContract: QuotationModel = new QuotationModel();
  quotationStateString: string = '';
  quotationStateOpen: number = QuotationStateEnums.open;
  quotationStateClosed: number = QuotationStateEnums.closed;
  quotationPrintContract: QuotationPrintModel = new QuotationPrintModel();
  quotationId: number = 0;
  requiredPriceList: boolean = true;
  selectedVersionModel: QuotationVersionModel = new QuotationVersionModel();
  stateText: string = 'Abierta';
  stateButton: { icon: string; title: string; severity: 'info' | 'success'; disabled: boolean };
  stateClientId: number | null = 0;
  stateConstructionSiteId: number = ConstructionSiteStateEnums.activa;
  stateRentalPeriod: boolean = false;
  subscription: Subscription;
  swGenerateOrderFromQuotation: boolean = false;
  url: string = "quotation";
  userAuthenticated: UserModel = new UserModel();
  updateListDetail: boolean = false;
  visibleState: boolean = false;
  viewAllQuotation: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private confirmDialogService: ConfirmDialogService,
    private dateConverterService: DateConverterService,
    private formatService: FormatService,
    private formBuilder: UntypedFormBuilder,
    private generalParameterService: GeneralParameterService,
    private headerService: HeaderService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private orderService: OrderService,
    private quotationService: QuotationService,
    private quotationVersionService: QuotationVersionService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService
  ) { }

  async ngOnInit() {
    await this.validateForm(new QuotationModel());
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    await this.getPermission();
    await this.getGeneralParameter();
    this.activatedRoute.params.subscribe(params => {
      this.quotationId = Object.keys(params).length > 0 ? Number(params?.id) : 0;
    });
    this.handleInitialState();

    this.subscription = this.outputForVersionModals$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'select':
          await this.changeQuotationVersion(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputForRejectQuotation$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'updateQuotation':
          this.quotationContract = payload;
          this.validateForm(this.quotationContract);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputForAttachFiles$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'uploadFile':
          this.uploadFile(payload);
          break;
        case 'downloadFile':
          this.downloadFile(payload);
          break;
        case 'deleteFile':
          this.deleteFile(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

    this.subscription = this.outputForPrintQuotation$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'printQuotation':
          this.printPage(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });

  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    this.listObservers.forEach(sub => sub.unsubscribe());
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  applyPriceListRules(quotationTypeId: number) {
    const priceListIdControl = this.formQuotation.get('priceListId');
    if (!priceListIdControl) return;

    this.requiredPriceList = Number(quotationTypeId) === QuotationTypesEnums.rental;
    if (this.requiredPriceList) {
      priceListIdControl.setValidators([Validators.required, Validators.min(1)]);
      if (!this.disabledForm && this.permissionUpdatable) priceListIdControl.enable({ emitEvent: false });
    } else {
      priceListIdControl.clearValidators();
      priceListIdControl.disable({ emitEvent: false });
    }
    priceListIdControl.updateValueAndValidity({ emitEvent: false });
  }

  defaultData() {
    const seller = this.listSellers.find(x => x.userId == this.userAuthenticated.userId) ?? null;
    if (seller) {
      this.getSeller(seller.value);
      const control = this.formQuotation.controls["sellerId"];
      this.viewAllQuotation ? control.enable() : control.disable();
    }
  }

  async changeConsecutive() {
    const branchId = this.formQuotation.get("branchId")?.value;
    let consecutive = this.formQuotation.get("consecutive")?.value;

    if (this.quotationContract.consecutive == consecutive) return;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    if (consecutive == null) {
      await this.resetQuotation(branchId);
      return;
    }

    try {
      this.quotationContract = await firstValueFrom(this.quotationService.getQuotationByKeysAsync(branchId, consecutive));
      this.quotationId = this.quotationContract.quotationId;
      await this.validateForm(this.quotationContract);
      this.getLastQuotationVersion(this.quotationContract.quotationId)
    } catch (error) {
      console.error('Error al buscar la cotización por campos de recuperación.', error);
      await this.validateForm(this.quotationContract);
    }
  }

  changeDateQuotation() {
    this.disabledButtons();
    const date = this.formQuotation.get("dateQuotation")?.value;
    if (date) {
      const dateExpiration = moment(date).add(30, 'days').toDate();
      this.formQuotation.get("dateExpiration")?.patchValue(dateExpiration);
    }
  }

  async changeSellerByConstructionSite(sellerConstructionSite: number) {
    const sellerId = this.formQuotation.get("sellerId")?.value;
    if (sellerId) {
      if (sellerId !== sellerConstructionSite) {
        const accepted = await this.confirmDialogService.confirm('El vendedor es diferente al de la obra. ¿Desea cambiarlo?');
        if (accepted) {
          this.getSeller(sellerConstructionSite);
        }
      }
    } else {
      this.getSeller(sellerConstructionSite);
    }
  }

  async changeQuotationVersion(quotationVersion: QuotationVersionModel) {
    await this.getQuotationVersionsForSelect(this.quotationId);
    if (quotationVersion.quotationVersionId != 0) {
      this.formQuotation.controls["versionId"].patchValue(quotationVersion.quotationVersionId);
      this.selectedVersionModel = quotationVersion;
    } else {
      if (this.listVersions.length != 0) {
        this.getLastQuotationVersion(this.quotationContract.quotationId)
      } else {
        this.formQuotation.controls["versionId"].patchValue(null);
        this.selectedVersionModel = new QuotationVersionModel;
      }
    }
  }

  async createNewQuotation() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear cotizaciones. Comuníquese con el administrador del sistema.', 'Atención');
      return;
    }

    this.quotationId = 0;
    this.quotationContract = new QuotationModel();
    this.quotationContract.branchId = this.branchId;
    this.costCenterDetailsCount = 0;
    this.quantityDetails = 0;
    this.orderConsecutive = '';
    this.filterConstructionSites(null, null, false);
    this.selectedVersionModel = new QuotationVersionModel();
    const [{ value: typeBussiness1Id }] = this.listTypesBussinesses1;
    this.quotationContract.conceptIdTypeBussiness1 = typeBussiness1Id;
    const [{ value: typeBussiness2Id }] = this.listTypesBussinesses2;
    this.quotationContract.conceptIdTypeBussiness2 = typeBussiness2Id;
    const [{ value: typeEquipmentId }] = this.listTypesEquipment;
    this.quotationContract.conceptIdTypeEquipment = typeEquipmentId;

    await this.validateForm(this.quotationContract);
    this.defaultData();
    this.expandedForm = true;
    this.location.replaceState(`/quotation/register`);
  }

  async createOrdersFromQuotation() {
    if (!this.swGenerateOrderFromQuotation) return;
    const { quotationStateId, quotationTypeId } = this.quotationContract;
    if (quotationStateId != QuotationStateEnums.approved || quotationTypeId == QuotationTypesEnums.maintenance) return;

    if (!await this.confirmDialogService.confirm(
      `¿Desea crear los pedidos de la cotización ${this.quotationContract.consecutive}?`
    )) return;

    try {
      const ordersCreated = await firstValueFrom(this.quotationService.createOrdersFromQuotation(this.quotationId));
      this.toastHandlerService.showToast(
        'success',
        `Se crearon ${ordersCreated?.length ?? 0} pedido(s) exitosamente: ${ordersCreated?.join(', ') ?? ''}.`,
      );
      await this.getAssociatedOrderAsync(this.quotationId);
    } catch (error) {
      console.error('Error al crear los pedidos desde la cotización.', error);
    }
  }

  async getAssociatedOrderAsync(quotationId: number) {
    if (!quotationId) {
      this.orderConsecutive = '';
      this.orderId = 0;
      return;
    }

    try {
      const order = await firstValueFrom(this.orderService.getFirstOrderByQuotationIdAsync(quotationId));
      if (this.quotationId !== quotationId) return;
      this.orderId = order?.orderId ?? 0;
      this.orderConsecutive = order?.consecutive ? order.consecutive.toString() : '';
    } catch (error) {
      if (this.quotationId !== quotationId) return;
      console.error('Error al buscar el pedido asociado a la cotización.', error);
      this.orderConsecutive = '';
      this.orderId = 0;
    }
  }

  changeTypeQuotation() {
    if (this.quantityDetails != 0) {
      this.toastHandlerService.showToast('warning', 'No se puede cambiar el "tipo" si la cotización tiene detalle o solución.', 'Atención');
      setTimeout(() => {
        this.formQuotation.controls['quotationTypeId'].patchValue(this.quotationContract.quotationTypeId);
      }, 100);
      return;
    }
  }

  async deleteFile(file: any) {
    if (this.quotationContract.quotationId != 0) {
      const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar el adjunto seleccionado?');
      if (accepted) {
        try {
          await firstValueFrom(this.quotationService.deleteFilesToQuotation(this.quotationContract.quotationId, file));
          this.toastHandlerService.showToast('success', 'El adjunto fue eliminado exitosamente', '');
          this.getFilesToQuotation();
        } catch (error) {
          console.error('Error catch:', error);
        }
      }
    }
  }

  downloadFile(fileName: any) {
    if (this.quotationContract.quotationId != 0) {
      this.quotationService.downloadFileToQuotation(this.quotationContract.quotationId, fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }

  downloadConditionsFile() {
    const isRentalSale = this.quotationContract.quotationTypeId == OrderTypeEnums.rental ? true : false;
    this.branchService.downloadConditions(this.quotationContract.branchId, isRentalSale).subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const fileBlob = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.style.display = 'none';
          document.body.appendChild(a);
          a.href = URL.createObjectURL(fileBlob);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }


  async deleteQuotation() {
    if (!this.validations()) return;

    if (this.quotationContract.quotationStateId != QuotationStateEnums.open) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar, la cotización no está abierta.', 'Atención');
      return;
    }

    if (this.quantityVersions > 0) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar, la cotización tiene versiones.', 'Atención');
      return;
    }

    const accepted = await this.confirmDialogService.confirm(`¿Realmente desea eliminar la cotización ${this.quotationContract.consecutive}?`);
    if (accepted) {
      try {
        await firstValueFrom(this.quotationService.deleteQuotation(this.quotationContract.quotationId));
        this.toastHandlerService.showToast('success', 'La cotización fue eliminada exitosamente.', '');
        this.createNewQuotation();
      } catch (error) {
        console.error('Error al eliminar la cotización.', error);
      }
    }
  }

  disabledButtons() {
    this.disabledDetail = true;
    this.disabledBtnVersion = true;
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  filterConstructionSites(clientId: number | null, previousClientId: number | null, onChange: boolean) {
    if (!clientId) {
      this.filteredConstructionSites = this.listConstructionSites;
      this.formQuotation.patchValue({ constructionSiteId: null });
    } else if (clientId !== previousClientId) {
      if (onChange) this.formQuotation.patchValue({ constructionSiteId: null });
      this.filteredConstructionSites = this.listConstructionSites.filter(x => x.clientId === clientId);
    }
  }

  async getAllLists() {
    try {
      const [branches, clients, typesBussinesses1, typesBussinesses2, typesEquipment, typesQuotations] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.quotationService.getAllClientsForSelect()),
        firstValueFrom(this.quotationService.getAllTypesBussinesses1ForSelect()),
        firstValueFrom(this.quotationService.getAllTypesBussinesses2ForSelect()),
        firstValueFrom(this.quotationService.getAllTypesEquipmentForSelect()),
        firstValueFrom(this.quotationService.getAllTypesQuotationsForSelect())
      ]);
      this.listBranches = branches;
      this.listClients = clients;
      this.listTypesBussinesses1 = typesBussinesses1;
      this.listTypesBussinesses2 = typesBussinesses2;
      this.listTypesEquipment = typesEquipment;
      this.listTypesQuotations = typesQuotations;

      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getAllListsByBranch() {
    try {
      const [constructionSites, pricesList, sellers] = await Promise.all([
        firstValueFrom(this.quotationService.getAllConstructionSitesForSelect(this.branchId)),
        firstValueFrom(this.quotationService.getAllPricesListForSelect(this.branchId)),
        firstValueFrom(this.quotationService.getAllSellersForSelect(this.branchId))
      ]);

      this.filteredConstructionSites = this.listConstructionSites = constructionSites;
      this.listPricesList = pricesList;
      this.listSellers = sellers;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas por sucursal.', error);
      return false;
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    let validBranch = null;
    if (branchId != null) {
      this.branchContract = await firstValueFrom(this.branchService.getBranchById(branchId));
      if (this.branchContract) {
        validBranch = branchId;
      }
    }
    this.branchId = validBranch ?? 0;
    this.formQuotation.controls["branchId"].patchValue(validBranch);
    await this.getAllListsByBranch();
    if (reload) {
      this.createNewQuotation();
    }
  }

  getButtonClick(buttonClick: any) {
    let consecutive = this.formQuotation.get("consecutive")?.value;
    const branchId = this.formQuotation.get("branchId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }
    consecutive = consecutive === 0 ? null : consecutive;
    this.handleQuotationNavigation(buttonClick, branchId, consecutive);
  }

  getClass(selection: 'client' | 'constructionSite'): string {
    const stateKey = selection === 'client' ? 'clientStateId' : 'stateConstructionSiteId';
    const newClass = this[stateKey] === ClientStateEnums.activo ? '' : 'state-inactive';
    return newClass;
  }

  async getClient(clientId: number | null, onChange: boolean) {
    const previousClientId = this.quotationContract.clientId;

    if (this.costCenterDetailsCount !== 0) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible cambiar el cliente, la cotización tiene detalle.'
      );
      setTimeout(() =>
        this.formQuotation.controls["clientId"].setValue(previousClientId)
      );
      return;
    }

    this.filterConstructionSites(clientId, previousClientId, onChange);

    const id = clientId ?? null;
    await this.setClientId(id);
    if (onChange) {
      await this.setConstructionSiteId(null, true);
    }
  }

  async getConstructionSite(constructionSiteId: number | null) {
    const previousContructionSiteId = this.quotationContract.constructionSiteId;
    if (previousContructionSiteId === constructionSiteId) {
      return;
    }

    if (this.costCenterDetailsCount !== 0) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible cambiar la obra, la cotización tiene detalle.'
      );
      setTimeout(() =>
        this.formQuotation.controls["constructionSiteId"].patchValue(previousContructionSiteId)
      );
      return;
    }

    const id = constructionSiteId ?? null;
    await this.setConstructionSiteId(id, true);
  }

  async getFilesToQuotation() {
    try {
      this.listFiles = await firstValueFrom(this.quotationService.getFilesToQuotation(this.quotationId));
      this.updateInputsForAttachFiles();
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  getFirstBranchByUserAuthenticatedAsync() {
    const load = this.branchService.getFirstBranchByUserAuthenticatedAsync().subscribe(response => {
      this.listObservers.push(load);
      this.getBranch(response.branchId, false);
      this.companyId = response.companyId;
    });
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0)
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.quotation));
  }

  async getGeneralParameter() {
    try {
      const generalParameters = await firstValueFrom(this.generalParameterService.getGeneralParametersByUserAutheticated());
      this.swGenerateOrderFromQuotation = generalParameters.some(x => x.generalParameterId === GeneralParameterEnums.generarPedidoDesdeCotizacion);
    } catch (error) {
      console.error('Error al obtener los parámetros generales.', error);
    }
  }


  async getLastQuotationVersion(quotationId: number) {
    this.selectedVersionModel = await firstValueFrom(this.quotationVersionService.getLastQuotationVersion(quotationId));
    this.formQuotation.controls["versionId"].patchValue(this.selectedVersionModel.quotationVersionId);
    this.location.replaceState(`/quotation/register/${this.quotationId}`);
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`, 'Atención');
      }
    } else {
      localStorage.clear();
    }

    await Promise.all([
      this.getFirstBranchByUserAuthenticatedAsync()
    ]);

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();
      await this.getPermissionQuotation();
      await this.getAllLists();
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionQuotation() {
    try {
      this.viewAllQuotation = await firstValueFrom(this.quotationService.getPermission(this.userAuthenticated));
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Quotation));
  }

  async getPriceList(priceListId: number | null) {
    const previousPriceListId = this.quotationContract.priceListId;
    if (previousPriceListId === priceListId) {
      return;
    }

    if (priceListId) {
      this.formQuotation.controls["priceListId"].patchValue(priceListId);
    } else {
      this.formQuotation.controls["priceListId"].patchValue(null);
    }

    this.disabledButtons();
  }

  async getQuotationPrint(versionPrint: any) {
    try {
      this.quotationPrintContract = await firstValueFrom(this.quotationService.getQuotationByKeysByPrint(versionPrint.quotationVersionId, null, null, versionPrint.swBreakdown));
    } catch (error) {
      console.error("Error al obtener la remisión:", error);
      this.quotationPrintContract = new QuotationPrintModel();
    }
  }

  async getVersionSelect(versionId: number) {
    const previousQuotationVersionId = this.selectedVersionModel.quotationVersionId;
    if (previousQuotationVersionId === versionId) {
      return;
    }

    if (versionId) {
      this.formQuotation.controls["versionId"].patchValue(versionId);
      this.selectedVersionModel = await firstValueFrom(this.quotationVersionService.getQuotationVersionById(versionId));
    } else {
      this.formQuotation.controls["versionId"].patchValue(null);
    }

    this.disabledButtons();
  }

  async getQuotationById() {
    try {
      this.quotationContract = await firstValueFrom(this.quotationService.getQuotationById(this.quotationId));
      this.quotationId = this.quotationContract.quotationId;
      this.branchId = this.quotationContract.branchId;
      this.filterConstructionSites(this.quotationContract.clientId, null, false);
      await this.validateForm(this.quotationContract);
    } catch (error) {
      console.error('Error al buscar la cotización.', error);
    }
  }

  async getQuotationVersionsForSelect(quotationId: number) {
    this.listVersions = await firstValueFrom(this.quotationVersionService.getQuotationVersionsForSelect(quotationId));
    this.quantityVersions = this.listVersions.length;
  }

  async getSeller(sellerId: number | null) {
    const previousSellerId = this.quotationContract.sellerId;
    if (previousSellerId === sellerId) {
      return;
    }

    if (sellerId) {
      if (this.costCenterDetailsCount !== 0) {
        const accepted = await this.confirmDialogService.confirm('La cotización tiene artículos asociados. ¿Realmente desea modificar el vendedor?');
        const confirmedSellerId = accepted ? sellerId : previousSellerId;
        this.formQuotation.controls["sellerId"].patchValue(confirmedSellerId);
      } else {
        this.formQuotation.controls["sellerId"].patchValue(sellerId);
      }
    } else {
      if (this.costCenterDetailsCount !== 0) {
        this.toastHandlerService.showToast('warning', 'No es posible limpiar la obra si el cotización tiene detalle.', 'Atención');
      } else {
        this.formQuotation.controls["sellerId"].patchValue(null);
      }
    }

    this.disabledButtons();
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/quotation']);
  }

  async getTypeBussiness1(typeBussiness1Id: number | null) {
    const previousTypeBussiness1Id = this.quotationContract.conceptIdTypeBussiness1;
    if (previousTypeBussiness1Id === typeBussiness1Id) {
      return;
    }

    if (typeBussiness1Id) {
      this.formQuotation.controls["conceptIdTypeBussiness1"].patchValue(typeBussiness1Id);
    } else {
      this.formQuotation.controls["conceptIdTypeBussiness1"].patchValue(null);
    }

    this.disabledButtons();
  }

  async getTypeBussiness2(typeBussiness2Id: number | null) {
    const previousTypeBussiness2Id = this.quotationContract.conceptIdTypeBussiness2;
    if (previousTypeBussiness2Id === typeBussiness2Id) {
      return;
    }

    if (typeBussiness2Id) {
      this.formQuotation.controls["conceptIdTypeBussiness2"].patchValue(typeBussiness2Id);
    } else {
      this.formQuotation.controls["conceptIdTypeBussiness2"].patchValue(null);
    }

    this.disabledButtons();
  }

  async getTypeEquipment(typeEquipmentId: number | null) {
    const previousTypeBussiness1Id = this.quotationContract.conceptIdTypeEquipment;
    if (previousTypeBussiness1Id === typeEquipmentId) {
      return;
    }

    if (typeEquipmentId) {

      this.formQuotation.controls["conceptIdTypeEquipment"].patchValue(typeEquipmentId);
    } else {
      this.formQuotation.controls["conceptIdTypeEquipment"].patchValue(null);
    }

    this.disabledButtons();
  }

  getUpdateListDetail() {
    this.updateListDetail = !this.updateListDetail;
  }

  async handleInitialState() {
    if (this.quotationId !== null && this.quotationId !== 0) {
      await this.getQuotationById();
    } else {
      this.createNewQuotation();
    }
  }

  private async handleQuotationNavigation(buttonClick: any, branchId: number, consecutive: number | null) {
    const actionMap: Record<string, () => Promise<QuotationModel>> = {
      first: () => firstValueFrom(this.quotationService.getFirstQuotationByKeysAsync(branchId)),
      previus: () => firstValueFrom(this.quotationService.getPreviusQuotationByKeysAsync(branchId, consecutive)),
      next: () => firstValueFrom(this.quotationService.getNextQuotationByKeysAsync(branchId, consecutive)),
      last: () => firstValueFrom(this.quotationService.getLastQuotationByKeysAsync(branchId))
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      return;
    }

    try {
      const quotation = await action();
      this.quotationContract = quotation;
      this.quotationId = quotation.quotationId;
      await this.validateForm(quotation);
      this.filterConstructionSites(quotation.clientId, null, false);
      this.getLastQuotationVersion(this.quotationContract.quotationId);
    } catch (error) {
      console.error(`Error al buscar la cotización (${buttonClick.target.id}).`, error);
    }
  }

  openQuotationVersionModal() {
    this.inputsForVersionModals$.next({
      quotationModel: this.quotationContract,
      permissionUpdatable: this.permissionUpdatable
    });
    this.versionModalComponent && this.versionModalComponent.show();
  }

  openRejectQuotation() {
    this.inputsForRejectQuotation$.next({
      quotationModel: this.quotationContract,
    });
    this.rejectQuotationComponent && this.rejectQuotationComponent.show();
  }

  async openRegisterModal() {
    if (this.quotationContract.quotationId == 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la cotización.', 'Atención');
      return;
    }

    this.inputsForRegisterModal$.next({
      quotationModel: this.quotationContract,
      permissionUpdatable: this.permissionUpdatable,
      listTypesBussinesses1: this.listTypesBussinesses1,
      listTypesBussinesses2: this.listTypesBussinesses2,
      listTypesEquipment: this.listTypesEquipment,
    });
    this.registerModalComponent?.show();
  }

  openPrintQuotationByVersion() {
    if (!this.validations()) return;

    if (this.quotationContract.quotationStateId == QuotationStateEnums.open) {
      this.toastHandlerService.showToast('warning', 'La cotización está "Abierta". Ciérrela e intente de nuevo.', 'Atención');
      return;
    }

    if (this.quantityDetails == 0) {
      this.toastHandlerService.showToast('warning', 'No es posible imprimir la cotización, no tiene ningún detalle', 'Atención');
      return;
    }

    if (this.branchContract.swAttachConditions) {
      const isRental = this.quotationContract.quotationTypeId === OrderTypeEnums.rental;
      const conditions = isRental ? this.branchContract.rentalConditions : this.branchContract.saleConditions;
      if (!conditions) {
        this.toastHandlerService.showToast(
          'warning',
          `Aún no se han adjuntado las condiciones comerciales de ${isRental ? 'alquiler' : 'venta'} en la sucursal.`,
          'Atención'
        );
        return;
      }
    }

    this.inputsForPrintQuotation$.next({
      selectedVersionContract: this.selectedVersionModel,
      listVersions: this.listVersions
    });
    this.printQuotationComponent && this.printQuotationComponent.show();
  }

  async openAttachFile() {
    if (!this.validations()) return;
    await this.getFilesToQuotation();


    this.attachFileComponent && this.attachFileComponent.show();
  }

  async printPage(versionPrint: any) {
    this.toastHandlerService.clearAllToasts();

    await this.getFormatByCompanyAndCode();
    await this.getQuotationPrint(versionPrint);
    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();

    if (this.formQuotation.controls["swConditions"].value && this.branchContract.swAttachConditions) {
      this.downloadConditionsFile();
    }
  }

  async reloadRegisterModal(params: any) {
    if (params.updateQuotation) {
      await this.getQuotationById();
    }
  }

  async resetQuotation(branchId: number) {
    this.quotationId = 0;
    this.quotationContract = new QuotationModel();
    this.quotationContract.branchId = branchId;
    this.costCenterDetailsCount = 0;
    this.stateConstructionSiteId = ConstructionSiteStateEnums.activa;
    this.clientStateId = ClientStateEnums.activo;
    await this.validateForm(this.quotationContract);
  }

  async revertStateQuotation() {
    if (this.permissionUpdatable) {
      const accepted = await this.confirmDialogService.confirm('¿Realmente desea revertir al estado anterior?');
      if (accepted) {
        this.quotationContract = await firstValueFrom(this.quotationService.revertStateQuotation(this.quotationId));
        this.validateForm(this.quotationContract);
        this.toastHandlerService.showToast('success', 'El estado se modifico exitosamente.', '');
      }
    } else {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para modificar los estados de la cotización. Comuníquese con el administrador del sistema.', 'Atención');
    }
  }

  async setClientId(clientId: number | null) {
    if (clientId) {
      const client = await firstValueFrom(this.quotationService.getClientByIdForSelect(clientId));
      this.formQuotation.controls["clientId"].patchValue(clientId);
      this.formQuotation.controls["nameClient"].patchValue(client.name);
      this.clientStateId = client.clientStateId;
    } else {
      this.formQuotation.controls["clientId"].patchValue(null);
      this.formQuotation.controls["nameClient"].patchValue("");
      this.clientStateId = ClientStateEnums.activo;
    }
    this.disabledButtons();
  }

  async setConstructionSiteId(constructionSiteId: number | null, onChange: boolean) {
    if (constructionSiteId) {
      const constructionSite = await firstValueFrom(this.quotationService.getConstructionSiteByIdForSelect(constructionSiteId));
      this.formQuotation.controls["constructionSiteId"].patchValue(constructionSiteId);
      this.formQuotation.controls["nameConstructionSite"].patchValue(constructionSite.name);
      this.stateConstructionSiteId = constructionSite.constructionSiteStateId;
      if (onChange) {
        this.getClient(constructionSite.clientId, false);
        this.changeSellerByConstructionSite(constructionSite.sellerId);
      }
    } else {
      this.formQuotation.controls["constructionSiteId"].patchValue(null);
      this.formQuotation.controls["nameConstructionSite"].patchValue("");
      this.stateConstructionSiteId = ConstructionSiteStateEnums.activa
    }
    this.disabledButtons();
  }

  async send() {
    if (this.disabledForm) {
      this.toastHandlerService.showToast('warning', 'No es posible guardar, la cotización no está ABIERTA', 'Atención');
      return;
    }

    Object.keys(this.formQuotation.controls).forEach(key => {
      const control = this.formQuotation.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });

    if (this.formQuotation.valid) {
      this.formQuotation.controls['consecutive'].enable();
      this.formQuotation.enable();

      const modelQuotation = this.formQuotation.getRawValue();


      this.quotationContract.dateQuotation = modelQuotation.dateQuotation;
      this.quotationContract.dateExpiration = modelQuotation.dateExpiration;
      this.quotationContract.quotationTypeId = modelQuotation.quotationTypeId;
      this.quotationContract.clientId = modelQuotation.clientId;
      this.quotationContract.nameClient = modelQuotation.nameClient;
      this.quotationContract.constructionSiteId = modelQuotation.constructionSiteId;
      this.quotationContract.nameConstructionSite = modelQuotation.nameConstructionSite;
      this.quotationContract.priceListId = modelQuotation.priceListId;
      this.quotationContract.sellerId = modelQuotation.sellerId;
      this.quotationContract.swConditions = modelQuotation.swConditions;

      if (this.quotationId == 0) {
        try {
          this.quotationContract = await firstValueFrom(this.quotationService.createQuotation(this.quotationContract));
          this.toastHandlerService.showToast('success', 'La cotización fue creada exitosamente', '');
          this.quotationId = this.quotationContract.quotationId;
        } catch (error) {
          console.error('Error al crear la cotización.', error);
          return;
        }
      } else {
        this.quotationContract.dateQuotation = modelQuotation.dateQuotation;
        this.quotationContract.dateExpiration = modelQuotation.dateExpiration;
        this.quotationContract.quotationTypeId = modelQuotation.quotationTypeId;
        this.quotationContract.clientId = modelQuotation.clientId;
        this.quotationContract.nameClient = modelQuotation.nameClient;
        this.quotationContract.constructionSiteId = modelQuotation.constructionSiteId;
        this.quotationContract.nameConstructionSite = modelQuotation.nameConstructionSite;
        this.quotationContract.priceListId = modelQuotation.priceListId;
        this.quotationContract.sellerId = modelQuotation.sellerId;
        this.quotationContract.swConditions = modelQuotation.swConditions;

        try {
          this.quotationContract = await firstValueFrom(this.quotationService.updateQuotation(this.quotationContract));
          this.toastHandlerService.showToast('success', 'La cotización fue modificada exitosamente', '');
        } catch (error) {
          console.error('Error al actualizar la cotización.', error);
          return;
        }
      }
      await this.validateForm(this.quotationContract);
      this.getLastQuotationVersion(this.quotationContract.quotationId);
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo sucursal es obligatorio.',
        min: 'Debes seleccionar una sucursal válida.'
      },
      dateQuotation: {
        required: 'El campo fecha cotización es obligatorio.'
      },
      dateExpiration: {
        required: 'El campo fecha caducidad es obligatorio.'
      },
      quotationTypeId: {
        required: 'El campo tipo cotización es obligatorio.'
      },
      nameClient: {
        required: 'El campo nombre cliente es obligatorio.',
        maxlength: 'El campo nombre cliente permite máximo 150 caracteres.'
      },
      nameConstructionSite: {
        maxlength: 'El campo nombre obra permite máximo 70 caracteres.'
      },
      priceListId: {
        required: 'El campo lista de precios es obligatorio.',
        min: 'Debes seleccionar una lista de precio válida.'
      },
      sellerId: {
        required: 'El campo vendedor es obligatorio.',
        min: 'Debes seleccionar un vendedor válido.'
      },
      quotationStateId: {
        required: 'El campo estado es obligatorio.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formQuotation.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  updateFormState() {
    const closeButton = { icon: 'pi pi-lock-open', title: 'Cerrar cotización', severity: 'info' };
    const approveButton = { icon: 'pi pi-verified', title: 'Aprobar/Rechazar', severity: 'success' };

    const stateConfig: any = {
      [QuotationStateEnums.open]: {
        tagSeverity: 'danger',
        text: 'Abierta',
        isDisabled: false,
        enableConsecutive: this.quotationId !== 0,
        button: { ...closeButton, disabled: this.quotationContract.quotationId == 0 },
      },
      [QuotationStateEnums.approved]: {
        tagSeverity: 'success',
        text: 'Aprobada',
        isDisabled: true,
        enableConsecutive: true,
        button: { ...approveButton, disabled: true },
      },
      [QuotationStateEnums.refused]: {
        tagSeverity: 'warn',
        text: 'Rechazada',
        isDisabled: true,
        enableConsecutive: true,
        button: { ...approveButton, disabled: true },
      },
      [QuotationStateEnums.closed]: {
        tagSeverity: 'info',
        text: 'Cerrada',
        isDisabled: true,
        enableConsecutive: true,
        button: { ...approveButton, disabled: false },
      }
    };
    const currentState = this.quotationContract.quotationStateId;
    const config = stateConfig[currentState];
    if (config) {
      this.severityState = config.tagSeverity;
      this.stateText = config.text;
      this.stateButton = config.button;
      this.disabledForm = config.isDisabled;
      this.disabledActions = config.isDisabled;
      this.disabledDetail = this.quotationContract.quotationId == 0 ? true : config.isDisabled;

      setTimeout(() => {
        config.isDisabled ? this.formQuotation.disable() : this.formQuotation.enable();
        const controls = this.formQuotation.controls;
        if (config.enableConsecutive) {
          controls['consecutive'].enable();
          controls['versionId'].enable();
        } else {
          controls['consecutive'].disable();
          controls['versionId'].disable();
        }
        this.applyPriceListRules(controls['quotationTypeId'].value);
      }, 100);
    }

    if (!this.permissionUpdatable) setTimeout(() => this.formQuotation.disable(), 100);
    setTimeout(() => this.formQuotation.controls["branchId"].enable(), 100);
  }

  updateInputsForAttachFiles() {
    this.inputsForAttachFiles$.next({
      listFiles: this.listFiles,
      labelConsecutive: this.quotationContract.consecutive,
      disabled: this.quotationContract.quotationStateId != QuotationStateEnums.open
    });
  }

  async updateStateVersion() {
    if (this.permissionUpdatable) {
      if (this.selectedVersionModel.quotationVersionId != 0) {
        const message = this.selectedVersionModel.active ? '¿Realmente desea cerrar la versión?' : '¿Realmente desea abrir la versión?';
        const accepted = await this.confirmDialogService.confirm(message);
        if (accepted) {
          try {
            this.selectedVersionModel = await firstValueFrom(this.quotationVersionService.setActive(this.selectedVersionModel.quotationVersionId));
            this.toastHandlerService.showToast('success', 'La versión se modificó exitosamente.', '');
          } catch (error) {
            console.error('Error catch:', error);
          }
        }
      } else {
        this.toastHandlerService.showToast('warning', 'Seleccione una versión válida.', 'Atención');

      }

    } else {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para modificar el estado de la versión. Comuníquese con el administrador del sistema.', 'Atención');
    }
  }

  async updateStateQuotation() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para modificar el estado de la cotización. Comuníquese con el administrador del sistema.', 'Atención');
      return;
    }

    const isOpen = this.quotationContract.quotationStateId == QuotationStateEnums.open;
    if (isOpen) {
      if (this.selectedVersionModel.active) {
        this.toastHandlerService.showToast('warning', 'No es posible cerrar la cotización; la versión aún está abierta', 'Atención');
        return;
      }
    } else {
      const accepted = await this.confirmDialogService.confirm("¿Desea aprobar la cotización?");
      if (!accepted) {
        this.openRejectQuotation();
        return;
      }
      if (this.quotationContract.clientId == null || this.quotationContract.clientId == 0) {
        this.toastHandlerService.showToast('warning', 'No es posible aprobar, debe seleccionar el cliente definitivo.', 'Atención');
        return;
      }
      if (this.quotationContract.constructionSiteId == null || this.quotationContract.constructionSiteId == 0) {
        this.toastHandlerService.showToast('warning', 'No es posible aprobar, debe seleccionar una obra definitiva.', 'Atención');
        return;
      }
      if (this.stateConstructionSiteId != ConstructionSiteStateEnums.activa) {
        this.toastHandlerService.showToast('warning', 'No es posible aprobar, la obra NO se encuetra activa.', 'Atención');
        return;
      }
    }

    try {
      this.quotationContract = await firstValueFrom(this.quotationService.setStateQuotation(this.quotationId));
      this.validateForm(this.quotationContract);
      if (isOpen) {
        this.toastHandlerService.showToast('success', 'La cotización se cerró exitosamente.', '');
      } else {
        this.toastHandlerService.showToast('success', 'La cotización se modificó exitosamente.', '');
        await this.createOrdersFromQuotation();
      }
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async uploadFile(formData: any) {
    try {
      await firstValueFrom(this.quotationService.attachFilesToQuotation(this.quotationId, formData));
      await this.getFilesToQuotation();
      this.toastHandlerService.showToast('success', 'Se adjunto el archivo exitosamente', '');
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para modificar cotizaciones. Comuníquese con el administrador del sistema', 'Atención');
      return false;
    }

    if (this.quotationContract.quotationId == 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la cotización.', 'Atención');
      return false;
    }
    return true;
  }

  async validateForm(quotation: QuotationModel) {
    this.formQuotation = this.formBuilder.group({
      branchId: [quotation.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [quotation.consecutive, []],
      dateQuotation: [quotation.dateQuotation ?
        this.dateConverterService.convertUtcToLocalDate(quotation.dateQuotation) : null, [Validators.required]],
      dateExpiration: [quotation.dateExpiration ?
        this.dateConverterService.convertUtcToLocalDate(quotation.dateExpiration) : null, [Validators.required]],
      quotationTypeId: [quotation.quotationTypeId, [Validators.required, Validators.min(1)]],
      clientId: [quotation.clientId, []],
      nameClient: [quotation.nameClient, [Validators.required, Validators.maxLength(150)]],
      constructionSiteId: [quotation.constructionSiteId, []],
      nameConstructionSite: [quotation.nameConstructionSite, [Validators.maxLength(70)]],
      priceListId: [quotation.priceListId, [Validators.required]],
      sellerId: [quotation.sellerId, [Validators.required, Validators.min(1)]],
      swConditions: [quotation.swConditions, []],
      quotationStateId: [quotation.quotationStateId, [Validators.required, Validators.min(1)]],
      versionId: []
    });

    this.updateFormState();
    this.validateRequiredPriceList();
    if (quotation.quotationId != 0) {
      await this.getQuotationVersionsForSelect(quotation.quotationId)
      await Promise.all([
        this.getPriceList(quotation.priceListId),
        this.getSeller(quotation.sellerId),
        this.getTypeBussiness1(quotation.conceptIdTypeBussiness1),
        this.getTypeBussiness2(quotation.conceptIdTypeBussiness2),
        this.getTypeEquipment(quotation.conceptIdTypeEquipment),
        this.getLastQuotationVersion(this.quotationId),
        this.getAssociatedOrderAsync(quotation.quotationId)
      ]);

      if (quotation.clientId) { this.setClientId(quotation.clientId); }
      if (quotation.constructionSiteId) { this.setConstructionSiteId(quotation.constructionSiteId, false); }

    }

  }

  validateRequiredPriceList() {
    // Escuchar cambios en quotationTypeId
    this.formQuotation.get('quotationTypeId')?.valueChanges.subscribe((value: number) => this.applyPriceListRules(value));
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      const check = async () => {
        if (this.finishLoadingPrint) {
          print();
          resolve();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  }
}
